/**
 * Loose string equality ignoring whitespace, underscores, parentheses and
 * case. Promoted from `src/lib/utils.ts` (D5 documents, ARCFE-990) — a pure
 * generic compare whose only D5 consumer carries context-file progress across
 * refetches by name.
 */
export const normalizedStringCompare = (str1: string, str2: string): boolean => {
  if (str1 === str2) {
    return true;
  }

  return (
    str1.replace(/[\s_()]/g, '').toLowerCase() ===
    str2.replace(/[\s_()]/g, '').toLowerCase()
  );
};
